import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type TranslationFn = (key: string, ...args: unknown[]) => string;

const noop: TranslationFn = (key: string) => key;
const TranslationContext = createContext<TranslationFn>(noop);

interface TranslationProviderProps {
  t: TranslationFn;
  children: ReactNode;
}

export const TranslationProvider = ({ t, children }: TranslationProviderProps) => {
  return <TranslationContext.Provider value={t}>{children}</TranslationContext.Provider>;
};

export const useTranslationContext = (): TranslationFn => {
  const t = useContext(TranslationContext);
  if (!t) {
    console.warn('[useTranslationContext] using noop, context value is falsy');
    return noop;
  }
  return (...args: Parameters<TranslationFn>) => {
    const [key, ...rest] = args;
    const result = t(key, ...rest);
    return result;
  };
};
